import {
  EncounterTemplateControllerApi,
  PhysicalROSTemplateRequest,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useRosPeTemplateCreate = () =>
  useMutationWithLoading(
    async (params: {
      physicalROSTemplateRequest: PhysicalROSTemplateRequest;
      xTENANTID?: string;
    }) =>
      new EncounterTemplateControllerApi(
        getConfigObject()
      ).createEncounterTemplate(
        params.physicalROSTemplateRequest,
        params.xTENANTID
      )
  );
